export default "__VITE_ASSET__BYvb8zwc__"